import { Link, LinkComponent } from '@tanstack/react-router'
import styled from 'styled-components'

export const Box = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

export const Connections: LinkComponent<typeof Link> = styled(Link)`
  color: var(--theme-colors-global-grey-grey500);
  text-decoration: none;
`

export const Arrow = styled.b`
  color: var(--theme-colors-global-grey-grey500);
`

export const Wrapper = styled.div`
  color: var(--theme-colors-global-general-secondary);
`
